import {
    collection, doc, query, updateDoc, where
} from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { Unit } from "../game/types/project";

type UseUnitProps = {
    data: Unit;
    status: "loading" | "error" | "success";
    updateUnit: (config: { unitId: string; values: { [key: string]: any } }) => void;
};

export default function useUnit(config?: { id?: string }): UseUnitProps {
    const { id = "" } = config || {};
    const DB = useFirestore();
    const COLLECTION = "units";

    const unitCollection = collection(DB, COLLECTION);

    const unitQuery = query(unitCollection, where("id", "==", id));

    let { status, data } = useFirestoreCollectionData(unitQuery);

    const updateUnit = async ({ unitId, values }: { unitId: string; values: { [key: string]: string } }) => {
        const unitRef = doc(DB, COLLECTION, unitId);

        await updateDoc(unitRef, values);
    }

    return {
        data: ((Array.isArray(data) && data.length > 0) ? data[0] : []) as Unit,
        status,
        updateUnit
    };
}
